import { application } from '@/controllers/application';

import Copy from '@/controllers/common/copy_controller';
import CreditCardForm from '@/controllers/common/credit_card_form_controller';
import FileField from '@/controllers/common/file_field_controller';
import Gallery from '@/controllers/common/gallery_controller';
import Heart from '@/controllers/common/heart_controller';
import HorizontalMenu from '@/controllers/common/horizontal_menu_controller';
import InstallApp from '@/controllers/common/install_app_controller';
import Lightbox from '@/controllers/common/lightbox_controller';
import Map from '@/controllers/common/map_controller';
import MaskAlphaSpace from '@/controllers/common/mask_alpha_space_controller';
import MaskCardCvv from '@/controllers/common/mask_card_cvv_controller';
import MaskCardExpirationMonth from '@/controllers/common/mask_card_expiration_month_controller';
import MaskCardExpirationYear from '@/controllers/common/mask_card_expiration_year_controller';
import MaskCardNumber from '@/controllers/common/mask_card_number_controller';
import MaskCnpj from '@/controllers/common/mask_cnpj_controller';
import MaskCpf from '@/controllers/common/mask_cpf_controller';
import MaskDate from '@/controllers/common/mask_date_controller';
import MaskMoney from '@/controllers/common/mask_money_controller';
import MaskNumber from '@/controllers/common/mask_number_controller';
import MaskPercentage from '@/controllers/common/mask_percentage_controller';
import MaskPhone from '@/controllers/common/mask_phone_controller';
import MaskState from '@/controllers/common/mask_state_controller';
import MaskZipCode from '@/controllers/common/mask_zip_code_controller';
import MegaMenu from '@/controllers/common/mega_menu_controller';
import Menu from '@/controllers/common/menu_controller';
import MenuActions from '@/controllers/common/menu_actions_controller';
import Modal from '@/controllers/common/modal_controller';
import NestedMove from '@/controllers/common/nested_move_controller';
import Rating from '@/controllers/common/rating_controller';
import Reveal from '@/controllers/common/reveal_controller';
import Theme from '@/controllers/common/theme_controller';
import Tip from '@/controllers/common/tip_controller';
import Upload from '@/controllers/common/upload_controller';
import ViewToggle from '@/controllers/common/view_toggle_controller';

import SiteChatsIndex from '@/controllers/site/chats/index_controller';
import SiteCoursesForm from '@/controllers/site/school_courses/form_controller';
import SiteInvoicesShow from '@/controllers/site/invoices/show_controller';
import SiteLinkTreesForm from '@/controllers/site/link_trees/form_controller';
import SiteLinkTreesIndex from '@/controllers/site/link_trees/index_controller';
import CreditCardsEdit from '@/controllers/site/credit_cards/edit_controller';
import CreditCardsNew from '@/controllers/site/credit_cards/new_controller';
import SitePaymentAccountsForm from '@/controllers/site/payment_accounts/form_controller';
import SiteSchoolsShow from '@/controllers/site/schools/show_controller';
import SiteSearchesIndex from '@/controllers/site/searches/index_controller';
import SitePaymentAccountsIndex from '@/controllers/site/payment_accounts/index_controller';
import SiteProductsShow from '@/controllers/site/products/show_controller';
import SiteChargeAttemptsIndex from '@/controllers/site/charge_attempts/index_controller';
import SiteSettingsForm from '@/controllers/site/settings/form_controller';
import SiteSettingsUserUnitAccesses from '@/controllers/site/settings/user_unit_accesses_controller';
import SiteTeachersForm from '@/controllers/site/teachers/form_controller';
import SiteTeachersShow from '@/controllers/site/teachers/show_controller';
import SiteTeachersIndex from '@/controllers/site/teachers/index_controller';
import SiteRhythmsIndex from '@/controllers/site/rhythms/index_controller';
import SiteUnitsCheckout from '@/controllers/site/units/checkout_controller';
import SiteUnitsForm from '@/controllers/site/units/form_controller';
import SiteUnitsIndex from '@/controllers/site/units/index_controller';
import SiteUnitsShow from '@/controllers/site/units/show_controller';
import SiteUnitsSubscription from '@/controllers/site/units/subscription_controller';
import SiteWithdrawsIndex from '@/controllers/site/withdraws/index_controller';
import SupportArticlesShow from '@/controllers/support/articles/show_controller';

application.register('copy', Copy);
application.register('credit-card-form', CreditCardForm);
application.register('file-field', FileField);
application.register('gallery', Gallery);
application.register('heart', Heart);
application.register('horizontal-menu', HorizontalMenu);
application.register('install-app', InstallApp);
application.register('lightbox', Lightbox);
application.register('map', Map);
application.register('mask-alpha-space', MaskAlphaSpace);
application.register('mask-card-cvv', MaskCardCvv);
application.register('mask-card-expiration-month', MaskCardExpirationMonth);
application.register('mask-card-expiration-year', MaskCardExpirationYear);
application.register('mask-card-number', MaskCardNumber);
application.register('mask-cnpj', MaskCnpj);
application.register('mask-cpf', MaskCpf);
application.register('mask-date', MaskDate);
application.register('mask-money', MaskMoney);
application.register('mask-number', MaskNumber);
application.register('mask-percentage', MaskPercentage);
application.register('mask-phone', MaskPhone);
application.register('mask-state', MaskState);
application.register('mask-zip-code', MaskZipCode);
application.register('mega-menu', MegaMenu);
application.register('menu', Menu);
application.register('menu-actions', MenuActions);
application.register('modal', Modal);
application.register('nested-move', NestedMove);
application.register('rating', Rating);
application.register('reveal', Reveal);
application.register('theme', Theme);
application.register('tip', Tip);
application.register('upload', Upload);
application.register('view-toggle', ViewToggle);

application.register('site--rhythms--index', SiteRhythmsIndex);
application.register('site--chats--index', SiteChatsIndex);
application.register('site--school-courses--form', SiteCoursesForm);
application.register('site--invoices--show', SiteInvoicesShow);
application.register('site--link-trees--form', SiteLinkTreesForm);
application.register('site--link-trees--index', SiteLinkTreesIndex);
application.register('site--credit-cards--edit', CreditCardsEdit);
application.register('site--credit-cards--new', CreditCardsNew);
application.register('site--payment-accounts--form', SitePaymentAccountsForm);
application.register('site--schools--show', SiteSchoolsShow);
application.register('site--searches--index', SiteSearchesIndex);
application.register('site--products--show', SiteProductsShow);
application.register('site--payment-accounts--index', SitePaymentAccountsIndex);
application.register('site--charge-attempts--index', SiteChargeAttemptsIndex);
application.register('site--settings--form', SiteSettingsForm);
application.register('site--settings--user-unit-accesses', SiteSettingsUserUnitAccesses);
application.register('site--teachers--form', SiteTeachersForm);
application.register('site--teachers--show', SiteTeachersShow);
application.register('site--teachers--index', SiteTeachersIndex);
application.register('site--units--checkout', SiteUnitsCheckout);
application.register('site--units--form', SiteUnitsForm);
application.register('site--units--index', SiteUnitsIndex);
application.register('site--units--show', SiteUnitsShow);
application.register('site--units--subscription', SiteUnitsSubscription);
application.register('site--withdraws--index', SiteWithdrawsIndex);
application.register('support--articles--show', SupportArticlesShow);

if (document.documentElement.dataset.env === 'development') {
  import('@/controllers/payment_simulator_controller').then(({ default: Controller }) => {
    application.register('payment-simulator', Controller);
  });
}
